import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaPaintBrush,
  FaBriefcase,
  FaUserTie,
  FaLaptopCode,
  FaAward,
  FaHandshake,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const ProfessionalEcommerceWebsiteDesignersInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Professional E-commerce Website Designers in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={
          <Subheading>Expert Design for Your Online Success</Subheading>
        }
        heading={
          <Heading>
            Professional{" "}
            <span tw="text-primary-500">E-commerce Website Designers</span> in
            Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, our team of professional e-commerce website
            designers in **Bur Dubai** crafts visually stunning, user-friendly,
            and high-performing online stores. We bring expertise and creativity
            to elevate your brand and drive business growth.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1587440871875-191322ee64b0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Professional web designer working
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Professional team meeting
          "https://images.unsplash.com/photo-1541462608143-67571c6738dd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // UX/UI design process
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Hire Our Designers"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert E-commerce Designers in Bur Dubai"
        description="Our professional team delivers exceptional design with a focus on results."
        cards={[
          {
            icon: <FaPaintBrush color="#ff5464" size={40} />,
            title: "Creative Excellence",
            description:
              "Stunning, custom designs that reflect your brand identity.",
          },
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Industry Experience",
            description:
              "Years of expertise in e-commerce design and development.",
          },
          {
            icon: <FaUserTie color="#ff5464" size={40} />,
            title: "Professional Approach",
            description: "Structured, reliable, and client-focused workflows.",
          },
          {
            icon: <FaLaptopCode color="#ff5464" size={40} />,
            title: "Technical Mastery",
            description: "Seamless integration of design and functionality.",
          },
          {
            icon: <FaAward color="#ff5464" size={40} />,
            title: "Award-Winning Quality",
            description:
              "Recognized for delivering top-tier e-commerce solutions.",
          },
          {
            icon: <FaHandshake color="#ff5464" size={40} />,
            title: "Collaborative Partnership",
            description: "Work with designers who prioritize your vision.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Professional Design Process"
        description={
          <Description>
            We combine creativity and precision to deliver exceptional
            e-commerce websites:
            <ul tw="mt-4 list-disc pl-6">
              <li>Discovery: Understand your brand, goals, and audience.</li>
              <li>Design: Craft visually appealing and intuitive layouts.</li>
              <li>
                Prototyping: Build interactive models for review and feedback.
              </li>
              <li>
                Development: Bring designs to life with clean, efficient code.
              </li>
              <li>Optimization: Enhance performance and user experience.</li>
              <li>
                Support: Offer ongoing assistance to keep your site thriving.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Designer creating e-commerce layout
          "https://images.unsplash.com/photo-1600132806370-bf17e65e942f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Professional design tools
          "https://images.unsplash.com/photo-1599041122665-d7a3fbe5a158?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Modern e-commerce interface
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Explore Our Process"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Proven Results from Our Designers"
        description="Our professional e-commerce designs have transformed businesses in Bur Dubai."
        cards={[
          {
            icon: <FaPaintBrush color="#ff5464" size={40} />,
            title: "Brand Elevation",
            description:
              "Redesigned a local store’s site, boosting brand recognition by 150%.",
          },
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Sales Surge",
            description:
              "Increased conversions by 180% with a custom e-commerce design.",
          },
          {
            icon: <FaAward color="#ff5464" size={40} />,
            title: "Client Accolades",
            description: "Earned rave reviews for professionalism and quality.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={
          <Subheading>Ready for a Professional E-commerce Site?</Subheading>
        }
        heading="Partner with Expert Designers in Bur Dubai"
        description={
          <Description>
            Elevate your online presence with MilaajBrandset’s professional
            e-commerce website designers in Bur Dubai. Let’s create a store that
            stands out and delivers results.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Professional design team collaborating
          "https://images.unsplash.com/photo-1575318634028-6a0cfcb60d0b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Dubai business district
          "https://images.unsplash.com/photo-1586717791821-3f44a563fa4c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Professional e-commerce website mockup
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Today"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
